import React from 'react';
import AfspraakComponent from '../components/Afspraak';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { Container, Alert, Box, CircularProgress, Typography } from '@mui/material';

const AfspraakPage = () => {
  const { currentUser, loading: authLoading, isCoach } = useAuth();
  
  if (authLoading) {
     return (
       <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
         <CircularProgress />
         <Typography sx={{ ml: 2 }}>Portaal laden...</Typography>
       </Box>
     );
  }

  if (!currentUser) {
    console.log("[AfspraakPage] No user found, redirecting to login.");
    return <Navigate to="/login" replace />;
  }

  if (isCoach()) {
    console.log("[AfspraakPage] User is coach, redirecting to /coach.");
    return <Navigate to="/coach" replace />;
  }
  
  console.log("[AfspraakPage] User is not coach, rendering AfspraakComponent.");
  return <AfspraakComponent />;
};

export default AfspraakPage; 